import { useFeatureFlags } from '@omnea-app/fe-org-settings/FeatureFlagsProvider'

export const useIsHostedCataloguesEnabled = () => {
  const { HOSTED_CATALOGUES } = useFeatureFlags()

  return HOSTED_CATALOGUES
}
